import { useCallback, useState } from "react";
import { useAuth } from "../AuthContext";
import Lobby from "./Lobby";
import Room from "./Room";
import LiveKitMeetingRoom from "../LiveKit/LiveKitMeetingRoom";
import { shouldUseLiveKit, type MeetingVideoEngine } from "../../utils/sessionMeeting";
import { useParams } from "react-router-dom";
import { SessionSettingsResponse } from "./types";

type MeetingProps = {
    /** Força o motor de vídeo (ex.: `/sala-beta/` sempre LiveKit). */
    forceEngine?: MeetingVideoEngine;
};

const Meeting = ({ forceEngine }: MeetingProps) => {
    const { user } = useAuth();
    const { roomId = "" } = useParams<{ roomId: string }>();
    const useLiveKit = shouldUseLiveKit(forceEngine);
    const [displayLobby, setDisplayLobby] = useState<boolean>(true);
    const [lobbyResponse, setLobbyResponse] = useState<SessionSettingsResponse | null>(null);
    const [selectedAvatarId, setSelectedAvatarId] = useState<string | null>(null);
    const [sessionIdentityKey, setSessionIdentityKey] = useState<string | null>(null);

    const onFinishConfiguration = useCallback(async (validationResponse: SessionSettingsResponse, avatarId: string | null, identityKey: string | null) => {
        if (!validationResponse) return;

        setDisplayLobby(false);
        setLobbyResponse(validationResponse);
        setSelectedAvatarId(avatarId);
        setSessionIdentityKey(identityKey);
    }, []);

    if (displayLobby) {
        return <Lobby
            user={user}
            roomId={roomId}
            forceEngine={forceEngine}
            onFinishConfiguration={onFinishConfiguration}
        />;
    }

    return useLiveKit ? (
        <LiveKitMeetingRoom
            user={user}
            roomId={roomId}
            sessionSetting={lobbyResponse}
            selectedAvatarId={selectedAvatarId}
            sessionIdentityKey={sessionIdentityKey}
            forceEngine={forceEngine}
        />
    ) : (
        <Room
            user={user}
            roomId={roomId}
            sessionSetting={lobbyResponse}
            selectedAvatarId={selectedAvatarId}
            sessionIdentityKey={sessionIdentityKey}
        />
    );
};

export default Meeting;
